<template>
    <app-sercheable-data-table :headers="headers" :search="search" :refresh="refresh" :pagination="pagination">
        <template slot="afterReloadButton" v-if="!readonly">
            <v-btn :to="{ name: 'systemCreate' }" color="primary">{{ $t('label.createSystem') }}</v-btn>
        </template>
        <template slot="items" slot-scope="{item}">
            <router-link :to="{ name: 'systemEdit', params: { id: item.id }}" tag="tr">
                <td class="system-acronym">{{ item.acronym }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.description }}</td>
            </router-link>
        </template>
    </app-sercheable-data-table>
</template>

<script>
// import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import SercheableDataTable from '../shared/SercheableDataTable';

export default {
    data() {
        return {
            pagination: {
                descending: true,
                sortBy: 'acronym',
            },
            headers: [
                {
                    text: this.$t('label.code'),
                    value: 'acronym',
                    align: 'left',
                },
                {
                    text: this.$t('label.name'),
                    value: 'name',
                    align: 'left',
                },
                {
                    text: this.$t('label.description'),
                    value: 'description',
                    align: 'left',
                    sortable: false,
                },
            ],
        };
    },

    computed: {
        readonly() {
            return !this.$store.getters.profile.isAdmin && !this.$store.getters.profile.isRoot;
        },
    },

    components: {
        appSercheableDataTable: SercheableDataTable,
    },

    methods: {
        search(filters) {
            const systems = this.$store.getters.systems;

            return utilities.filterMultiple(systems, filters, (system, regex) => (
                regex.test(system.acronym) ||
                regex.test(system.name) ||
                regex.test(system.description)
            ));
        },
        async refresh() {
            await this.$store.dispatch('loadSystems');
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/systems/Index.vue